'use client';
import styled from 'styled-components';

export const BannerLabel = styled.h1`
  color: ${({ theme }) => theme.palette.blue1100};
  margin-bottom: 0px;
  font-size: 28px;
  font-weight: 400;
  line-height: 40px;

  ${({ theme }) => theme.mediaQueries.LARGE_1X_UP} {
    font-size: 40px;
    font-weight: 400;
    line-height: 56px;
  }
`;

export const CampainBannerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 40px;

  ${({ theme }) => theme.mediaQueries.LARGE_1X_UP} {
    gap: 80px;
  }

  & > a {
    display: none;

    ${({ theme }) => theme.mediaQueries.LARGE_1X_UP} {
      display: block;
    }
  }
`;
